import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isLoggedIn = false;
  username: string | null = null;
  error: string | null = null;
  accessToken: string | null = null;
  infoDialogOpen = false;
  infoDialogTitle = 'Napaka';
  infoDialogMessage = '';

  constructor(private router: Router, private http: HttpClient, private authService: AuthService) { }

  ngOnInit(): void {
    // Check if user is already logged in
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/tarce']);
    }
  }

  onLoginClick(event: Event): void {
    event.preventDefault();
    const username = (<HTMLInputElement>document.getElementById('username')).value;
    const password = (<HTMLInputElement>document.getElementById('password')).value;

    const body = new HttpParams()
      .set('username', username)
      .set('password', password);

    this.http.post<any>(this.authService.apiUrl + '/api/tarce/login', body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).subscribe({
      next: (response) => {
        this.isLoggedIn = true;
        this.username = username;
        this.accessToken = response.access_token;

        // Store token, username, and unit_id in localStorage for later use
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('username', username);
        if (response.unit_id !== undefined) {
          localStorage.setItem('unit_id', response.unit_id.toString());
        }

        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token);
        }

        this.router.navigate(['/tarce']);
      },
      error: (error) => {
        console.error('Login error:', error);
        this.error = error.error?.detail || 'Napaka pri prijavi.';
        this.infoDialogMessage = this.error || 'Napaka pri prijavi.';
        this.infoDialogOpen = true;
      }
    });
  }

  onLogoutClick(): void {
    this.isLoggedIn = false;
    this.username = null;
    this.accessToken = null;
    this.router.navigate(['/']);
  }
}